export default "__VITE_ASSET__CVo20sF8__"